<template>
  <Dialog :visible="visible" class="irinox-dialog-light" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '500px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div v-if="mode=='lab'">{{$t('laboratories.add_lab_title')}}</div>
      <div v-if="mode=='appliance'">{{$t('dashboard.add_dialog_title')}}</div>
    </template>

    <div v-if="mode=='lab'" class="irinox-dialog-light-content layout-content">
      <div class="irinox-form p-pt-2">
        <div class="p-fluid p-formgrid p-grid p-pl-4 p-pr-4">
              <div class="p-field p-col">
                  <label for="add_lab_name">{{$t('laboratories.add_lab_name')}}</label>
                  <InputText id="add_lab_name" type="text" v-model="labName" 
                    :placeholder="$t('laboratories.add_lab_name_ph')"
                    :class="{'p-invalid':mode=='lab' && !labName && submitted}"
                    />
              </div>
          </div>
      </div>
    </div>

    <div v-if="mode=='appliance'" class="irinox-dialog-light-content layout-content">
      <div class="irinox-form p-pt-2">
        <div class="p-fluid p-formgrid p-grid p-pl-4 p-pr-4">
              <div class="p-field p-col-12">
                  <label for="add_dialog_code">
                    {{$t('dashboard.add_dialog_code')}} 
                    <i class="pi pi-info-circle" v-tooltip="$t('dashboard.add_dialog_code_tooltip')"/>
                  </label>
                  <InputText id="add_dialog_code" type="text" v-model="appliance.activationCode" 
                    :placeholder="$t('dashboard.add_dialog_code_ph')"
                    :class="{'p-invalid':mode=='appliance' && !appliance.activationCode && submitted}"
                    />
              </div>
              <div class="p-field p-col-12">
                  <label for="add_dialog_name">{{$t('dashboard.add_dialog_name')}}</label>
                  <InputText id="add_dialog_name" type="text" v-model="appliance.name" 
                    :placeholder="$t('dashboard.add_dialog_name_ph')"
                    :class="{'p-invalid':mode=='appliance' && !appliance.name && submitted}"
                    />
              </div>
              <div class="p-field p-col-12">
                  <label for="labs">{{$t('dashboard.add_dialog_lab')}}</label>
                  <Dropdown id="labs" v-model="appliance.lab" :options="labs" optionLabel="name" optionValue="id" 
                    :placeholder="$t('dashboard.add_dialog_lab_ph')" @change="changeLab" 
                    :class="{'p-invalid':mode=='appliance' && !appliance.lab && submitted}"/>
              </div>
          </div>
      </div>
    </div>

    <template #footer>
      <Button :label="$t('laboratories.add_lab_button')" @click="buttonClick"/>
    </template>
  </Dialog>
</template>

<script>
export default {
    emits: ['update:visible','click:button','click:open-share','click:open-lab'],
    props: {
      visible: Boolean,
      mode: String,
      labs: Array,
    },
    data() {
        return {
          submitted: false,
          labName: null,
          appliance: {
            activationCode: null,
            name: null,
            lab: null
          }
        };
    },
    methods: {
      updateVisible(value) {
        if(!value) {
          this.submitted = false;
          this.labName = null;
        }
        this.$emit("update:visible", value);
      },
      buttonClick() {
        this.submitted = true;

        if(this.mode=='lab') {
          if(!this.labName) {
            return;
          }
          this.$emit("click:button", this.labName);
        }

        if(this.mode=='appliance') {
          if(!this.appliance.activationCode || !this.appliance.name || !this.appliance.lab) {
            return;
          }
          this.$emit("click:button", {
            activationCode: this.appliance.activationCode,
            name: this.appliance.name,
            lab: this.appliance.lab
          });
        }

      },
      show() {
        this.submitted = false;
        this.labName = null;
      },
      changeLab() {
        if(this.appliance.lab!=null) {
          if(this.appliance.lab==-1) {
            this.appliance.lab = 0;
            this.$emit("click:open-lab");
          }
        }
      },
    }
}
</script>

<style>

</style>